import React from "react";
import { config } from "../config";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import scrap from "../../assets/images/scrap processing.png";
import cubes from "../../assets/images/ingots & cubes.png";
import melting from "../../assets/images/melting & refining.png";

const AboutSection = () => {

  return (
    <>
      <section class="features">
        <div class="container">

          <div class="header">
            <p class="subtitle">What Make Roliox Alloys Different From Others</p>
            <h1>WHAT WE DO</h1>
          </div>

          <div class="feature-grid">

            <div class="feature-box">
              <div class="icon light">
                <span><img src={scrap} width={110} /></span>
              </div>
              <h3>Aluminum Scrap Processing</h3>
              <p>
                We source and process different types of aluminum scrap efficiently, ensuring minimal waste and maximum recovery. 
              </p>
            </div>

            <div class="feature-box">
              <div class="icon light">
               <span><img src={melting} width={110} /></span>
              </div>
              <h3>Aluminum Melting & Refining</h3>
              <p>
               Our advanced melting furnaces ensure uniform composition and removal of impurities for superior output quality.
              </p>
            </div>

            <div class="feature-box">
              <div class="icon light">
               <span><img src={cubes} width={110} /></span>
              </div>
              <h3>Aluminum Ingot & Cube Manufacturing</h3>
              <p>
               We produce durable and high-grade aluminum ingots and cubes suitable for casting, extrusion, and industrial applications.
              </p>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default AboutSection;
